import React from 'react'
import styles from './Footer.module.css'

const FooterBar = () => {
    return (
        <footer className={styles.footer}>
            <a
                className={styles.links}
                href="https://www.beapplied.com/tat-privacy"
                target="_blank"
                rel="noopener noreferrer"
            >
                Privacy
            </a>
            <a
                className={styles.links}
                href="https://www.beapplied.com/tat-privacy"
                target="_blank"
                rel="noopener noreferrer"
            >
                Terms
            </a>
            <a
                className={styles.links}
                href="https://www.beapplied.com/tat-privacy"
                target="_blank"
                rel="noopener noreferrer"
            >
                Security
            </a>
            <div className={styles.footerCopyright}>
                Copyright © 2020 Be Applied Ltd.
            </div>
        </footer>
    )
}

export default FooterBar
